import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-section-group-layout.vue";
import { computed, defineComponent, toRefs, watch } from "@vue/composition-api";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import DateField from "@Shared/components/form-elements/fields/date-field.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { useLiabilityHelpers } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityHelpers";
import { liabilityValidator } from "@Client/@Composables/application-standalone/validations/liabilityValidator";
import { liabilitiesPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/liabilities/liabilitiesPageBindingsAndVisibilities";
import { get } from "lodash";
export default defineComponent({
  name: "LiabilityInformation",
  components: {
    PageSectionGroupLayout,
    SectionTitle,
    SelectField,
    CurrencyField,
    DateField,
    TextField
  },
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    liabilityIndex: {
      type: Number,
      required: true
    },
    applicantId: {
      type: String,
      required: true
    },
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const {
      applicantIndex,
      liabilityIndex,
      applicantId,
      showErrors
    } = toRefs(props);
    const {
      applicantNameFromIndex,
      allApplicants
    } = useApplicantHelpers();
    const applicantName = applicantNameFromIndex(applicantIndex.value);
    const {
      bindings,
      visibilities
    } = liabilitiesPageBindingsAndVisibilities(applicantIndex, liabilityIndex, applicantId);
    const {
      liabilityType,
      liabilityOwner,
      liabilityLimit,
      liabilityBalance,
      liabilityPayment,
      liabilityMaturityDate,
      liabilityPayoff,
      liabilityDescription
    } = bindings;
    const {
      liabilityTypeOptions,
      liabilityPayoffOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      filteredApplicantsAsOptions
    } = useLiabilityHelpers();
    const handleOwnerChange = newApplicantIndex => {
      if (typeof newApplicantIndex !== "number") return;
      liabilityOwner.value = newApplicantIndex;
      const applicant = allApplicants.value[newApplicantIndex];
      if (!applicant) return;
      const newLiabilityIndex = applicant.liabilities.length - 1;
      const newApplicantId = applicant.id;
      emit("navigate", {
        applicantIndex: newApplicantIndex,
        applicantId: newApplicantId,
        liabilityIndex: newLiabilityIndex
      });
    };
    const {
      liabilityTypeVisible,
      liabilityLimitVisible,
      liabilityBalanceVisible,
      liabilityPaymentVisible,
      liabilityMaturityDateVisible,
      liabilityPayoffVisible,
      liabilityDescriptionVisible
    } = visibilities;
    const {
      v$
    } = liabilityValidator(applicantIndex, liabilityIndex);
    const isValid = computed(() => {
      var _v$$value;
      return !(v$ != null && (_v$$value = v$.value) != null && _v$$value.$invalid);
    });
    const filteredLiabilityTypeOptions = computed(() => {
      if (liabilityType.value === "rent") return liabilityTypeOptions;
      return _filterInstanceProperty(liabilityTypeOptions).call(liabilityTypeOptions, liabilityTypeOption => liabilityTypeOption.value !== "rent");
    });
    watch(isValid, newVal => {
      emit("disable-save", !newVal);
    }, {
      immediate: true
    });
    watch(showErrors, newVal => {
      if (newVal) {
        var _v$$value2;
        v$ == null ? void 0 : (_v$$value2 = v$.value) == null ? void 0 : _v$$value2.$touch();
      }
    });
    const getValidator = path => get(v$.value, path, null);
    return {
      applicantName,
      liabilityType,
      liabilityOwner,
      liabilityTypeOptions,
      filteredLiabilityTypeOptions,
      applicantsAsOptions: filteredApplicantsAsOptions,
      handleOwnerChange,
      liabilityLimit,
      liabilityBalance,
      liabilityPayment,
      liabilityMaturityDate,
      liabilityPayoff,
      liabilityPayoffOptions,
      liabilityDescription,
      liabilityTypeVisible,
      liabilityLimitVisible,
      liabilityBalanceVisible,
      liabilityPaymentVisible,
      liabilityMaturityDateVisible,
      liabilityPayoffVisible,
      liabilityDescriptionVisible,
      v$,
      getValidator
    };
  }
});